export const SET_DISPLAY_PATHOLOGIES_COUNT = 'SET_DISPLAY_PATHOLOGIES_COUNT';

export const setDisplayPathologiesCount = (count) => ({
  type: SET_DISPLAY_PATHOLOGIES_COUNT,
  payload: count,
});
